import React from "react";
import { PublicClientApplication } from "@azure/msal-browser";
//import { MsalProvider } from "@azure/msal-react";
import App from "./App";

export default function AppWithMsal() {
  return (
      <App />
  );
}
